import { HttpActivityService } from '@app/core/services/http-activity.service';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

/** Counts every HttpClient request as in flight until it settles (HttpActivityService). Changes nothing about the request. */
export const httpActivityInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
    inject(HttpActivityService).track(next(request));
